import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TuiLet } from '@taiga-ui/cdk';
import { TuiTextfieldControllerModule, TuiSelectModule } from '@taiga-ui/legacy';
import { TuiDataList, TuiButton } from '@taiga-ui/core';
import { ComponentsModule } from '@src/app/components';
import { SharedModule } from '@src/app/shared';
import { InputFilesModule } from '@src/app/modules/input-files';

import { ImportOrganisationsComponent } from './import-organisations.component';
import { ImportService } from './services';

@NgModule({
  declarations: [ImportOrganisationsComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    ReactiveFormsModule,
    SharedModule,
    TuiButton,
    ...TuiDataList,
    TuiLet,
    TuiSelectModule,
    TuiTextfieldControllerModule,
    InputFilesModule,
  ],
  providers: [ImportService],
  exports: [ImportOrganisationsComponent],
})
export class ImportOrganisationsModule {}
